module.exports = __webpack_public_path__ + "static/Quote 3 - Mobile-e2d26e93533af6df0b2cff79281fd75b.png";